<template>
  <div>
    <batch-table :changeOrderCode="changeOrderCode" :disabled="disabled" />
  </div>
</template>

<script>
import BatchTable from './components/batch-table/index.vue'

export default {
  props: {
    changeOrderCode: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    BatchTable,
  },
}
</script>
